module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "com-model"
  }, [_c('div', {
    staticClass: "top-bar"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/index/company'
      }
    }
  }, [_vm._v("企业设置")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v(_vm._s(_vm.type === 'default' ? '企业基本信息' : _vm.type === 'location' ? '企业位置信息' : ''))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.type === 'default') ? _c('el-form', {
    ref: "form",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.companyInfo,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "公司简称",
      "prop": "shortName"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.companyInfo.shortName),
      callback: function($$v) {
        _vm.$set(_vm.companyInfo, "shortName", $$v)
      },
      expression: "companyInfo.shortName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "公司电话",
      "prop": "telephone"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.companyInfo.telephone),
      callback: function($$v) {
        _vm.$set(_vm.companyInfo, "telephone", $$v)
      },
      expression: "companyInfo.telephone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "行业类型",
      "prop": "industryId"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择行业类型"
    },
    model: {
      value: (_vm.companyInfo.industryId),
      callback: function($$v) {
        _vm.$set(_vm.companyInfo, "industryId", $$v)
      },
      expression: "companyInfo.industryId"
    }
  }, _vm._l((_vm.industryList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "企业规模",
      "prop": "scale"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择企业规模"
    },
    model: {
      value: (_vm.companyInfo.scale),
      callback: function($$v) {
        _vm.$set(_vm.companyInfo, "scale", $$v)
      },
      expression: "companyInfo.scale"
    }
  }, _vm._l((_vm.scaleList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "工厂简介",
      "prop": "description"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.companyInfo.description),
      callback: function($$v) {
        _vm.$set(_vm.companyInfo, "description", $$v)
      },
      expression: "companyInfo.description"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "60px",
      "margin-bottom": "0",
      "padding-bottom": "60px"
    }
  }, [_c('div', {
    staticClass: "flex flex-center"
  }, [_c('div', {
    staticClass: "primary-border-btn button",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('div', {
    staticClass: "primary-btn button",
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("保存修改")])])])], 1) : (_vm.type === 'location') ? _c('el-form', {
    ref: "form",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.companyInfo,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "所属区县"
    }
  }, [_c('el-cascader', {
    attrs: {
      "options": _vm.provinceArr
    },
    on: {
      "active-item-change": _vm.handleItemChange
    },
    model: {
      value: (_vm.selectOptions),
      callback: function($$v) {
        _vm.selectOptions = $$v
      },
      expression: "selectOptions"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "工厂地址"
    }
  }, [_c('el-input', {
    staticClass: "m-b-14",
    model: {
      value: (_vm.companyInfo.address),
      callback: function($$v) {
        _vm.$set(_vm.companyInfo, "address", $$v)
      },
      expression: "companyInfo.address"
    }
  }), _vm._v(" "), (_vm.mapShow) ? _c('TxMap', {
    ref: "TxMap",
    attrs: {
      "axis": {
        lng: _vm.lng,
        lat: _vm.lat
      }
    },
    on: {
      "updateAddress": _vm.updateAddress
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "60px",
      "margin-bottom": "0",
      "padding-bottom": "60px"
    }
  }, [_c('div', {
    staticClass: "flex flex-center"
  }, [_c('div', {
    staticClass: "primary-border-btn button",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('div', {
    staticClass: "primary-btn button",
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("保存修改")])])])], 1) : _vm._e()], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66c4c824","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/finance/companyBase.vue
// module id = 885
// module chunks = 1